import { FormFieldType } from "@/enums";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
export function isTextForm(fieldType) {
    return (fieldType === FormFieldType.Email ||
        fieldType === FormFieldType.TextField ||
        fieldType === FormFieldType.Password ||
        fieldType === FormFieldType.TextArea);
}
export function isSelect(fieldType) {
    return (fieldType === FormFieldType.MultiSelect ||
        fieldType === FormFieldType.Select ||
        fieldType === FormFieldType.RadioButton);
}
export function updateState(submission) {
    if (!submission)
        return {};
    const formValues = Object.values(submission.values);
    const values = {};
    for (let i = 0; i < formValues.length; i++) {
        const value = formValues[i];
        switch (value.type) {
            case FormFieldType.MultiSelect:
            case FormFieldType.RadioButton:
            case FormFieldType.Select:
                values[value.name] = value.selected_value;
                break;
            case FormFieldType.TextField:
            case FormFieldType.Email:
            case FormFieldType.TextArea:
            case FormFieldType.Password:
                values[value.name] = value.value;
                break;
            case FormFieldType.Numeric:
                values[value.name] = value.value.toString();
                break;
            case FormFieldType.Checkbox:
                values[value.name] = value.value.toString();
                break;
            case FormFieldType.Mask:
                values[value.name] = value.value;
                break;
        }
    }
    return values;
}
//# sourceMappingURL=utils.js.map